module.exports = __webpack_public_path__ + "img/services-shape-3.f29394a0.svg";